import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=1c105e4a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=1c105e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c105e4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c105e4a')) {
      api.createRecord('1c105e4a', component.options)
    } else {
      api.reload('1c105e4a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=1c105e4a&scoped=true&", function () {
      api.rerender('1c105e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Yr1tWhLzAUSZ/JS/teamMember.vue"
export default component.exports